import { equalHeight } from "../../common/equalHeight";

export default function initSimpleFilter() {
  document.querySelectorAll(".simple-filter")?.forEach((simpleFilter) => {
    const button = simpleFilter.querySelector(".simple-filter__button");
    const buttonLabel = simpleFilter.querySelector(
      ".simple-filter__button-label",
    );
    const menu = simpleFilter.querySelector(".simple-filter__menu");
    const menuIcon = simpleFilter.querySelector(".simple-filter__menu-icon");
    const menuItems = simpleFilter.querySelectorAll(
      ".simple-filter__menu-item",
    );

    // Select the first filter on load
    menuItems[0].querySelector("input").setAttribute("checked", "checked");

    let updatedButtonLabel = "";

    button.addEventListener("click", () => {
      if (button.classList.contains("open")) {
        button.classList.remove("open");
        menu.classList.remove("open");
        menuIcon.classList.remove("open");

        if (updatedButtonLabel) {
          buttonLabel.innerHTML = updatedButtonLabel;
        }
      } else {
        button.classList.add("open");
        menu.classList.add("open");
        menuIcon.classList.add("open");
      }
    });

    [...menuItems].forEach((item) => {
      item.addEventListener("click", () => {
        // Update the button label.
        updatedButtonLabel = item.querySelector(
          ".simple-filter__option-label",
        ).innerHTML;
        buttonLabel.innerHTML = updatedButtonLabel;

        // Hide the current visible panel.
        document
          .querySelector(".simple-filter__panel.open")
          ?.classList.remove("open");

        // Find the matching panel, and show it.
        let itemControls = item
          .querySelector("input")
          .getAttribute("aria-controls");

        let matchingPanel = document.querySelector(`#${itemControls}`);

        matchingPanel?.classList.add("open");

        // Handle testimonials quote heights
        if (
          document.getElementsByClassName("testimonials-quote__text-wrapper")
            .length
        ) {
          equalHeight(".testimonials-quote__text-wrapper");
          window.addEventListener("resize", () => {
            equalHeight(".testimonials-quote__text-wrapper");
          });
        }
      });
    });
  });
}
